import React from 'react';
import { ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { DateRangePicker } from '../DateRangePicker';
import { colors, spacing, typography } from '../../theme';
import { useLocale } from '../../contexts/LocaleContext';
import { useRTLStyles } from '../../hooks/useRTLStyles';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { VENDOR_PERIODS, VendorPeriod } from '../../utils/vendorPeriods';

export interface PeriodValue {
  period: VendorPeriod;
  from?: Date;
  to?: Date;
}

/** Period chips (7 / 30 / 90 days, this month, this year, all time) + a custom range. */
export const VendorPeriodBar: React.FC<{ value: PeriodValue; onChange: (value: PeriodValue) => void }> = ({ value, onChange }) => {
  const styles = useThemedStyles(getStyles);
  const { t } = useLocale();
  const rtl = useRTLStyles();
  return (
    <View style={[styles.row, { flexDirection: rtl.rowDirection }]}>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={[styles.chips, { flexDirection: rtl.rowDirection }]}>
        {VENDOR_PERIODS.map((p) => {
          const active = value.period === p;
          return (
            <TouchableOpacity key={p} style={[styles.chip, active && styles.chipActive]} onPress={() => onChange({ period: p })} activeOpacity={0.7}>
              <Text style={[styles.chipText, active && styles.chipTextActive]}>{t(`vendors.period.${p}` as any)}</Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
      <DateRangePicker
        preset="custom"
        startDate={value.period === 'custom' ? value.from : undefined}
        endDate={value.period === 'custom' ? value.to : undefined}
        onChange={(_preset, from, to) => onChange(from || to ? { period: 'custom', from, to } : { period: '30d' })}
      />
    </View>
  );
};

const getStyles = () => StyleSheet.create({
  row: { alignItems: 'center', gap: spacing.sm },
  chips: { gap: spacing.xs, paddingVertical: 2 },
  chip: { paddingVertical: 6, paddingHorizontal: spacing.md, borderRadius: 999, borderWidth: 1, borderColor: colors.border, backgroundColor: colors.background.surface },
  chipActive: { backgroundColor: colors.primary, borderColor: colors.primary },
  chipText: { fontSize: typography.fontSize.xs, color: colors.text.primary, fontWeight: '600' },
  chipTextActive: { color: colors.white },
});
